import { useaxios } from "../../../utils/useaxios";
export default (customer_id, loan_in_amount, loan_in_dollar_price, loan_in_note, user_id) => recaller => setrecaller => initDispatch => clear => setloan_in_id => printFn => setloan_loading => {
    var today = new Date();
    today = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate() + " " + today.getHours() + ":" + today.getMinutes() + ":" + today.getMinutes();
    // initDispatch({ type: 'loadingTrue' });
    useaxios('loan_in/create.php', { customer_id, loan_in_date: today, loan_in_amount, loan_in_dollar_price, loan_in_note, user_id }).then((res) => {
        if (res == "Unauthorized") {
            clear();
            return;
        } else if (res == "request_failed") {
            setloan_loading(false);
            alert('no internet connection');
            return false;
        } else if (res.status == "ok") {
            var temp_loan_id = res.loan_in_id;
            setloan_in_id(temp_loan_id);
            setTimeout(() => {
                printFn();
                setrecaller(recaller + 1);
                setloan_loading(false);
            }, 800);
        }
        // setloading(false);
    });
}